import { currency } from 'functions';
import { useState } from 'react';
import { Form } from 'react-bootstrap';
import Cards from 'react-credit-cards';
import InputMask from 'react-input-mask';

const MethodCard = ({
  offer,
  register,
  errors,
  installmentsList,
  paymentMethod,
  getValues,
}) => {
  const [fields, setFields] = useState({
    cvc: '',
    expiry: '',
    cardHolder: '',
    number: '',
    focused: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFields((prevFields) => ({ ...prevFields, [name]: value }));
  };

  const handleInputFocus = (e) => {
    const { name, value } = e.target;

    setFields((prevFields) => ({ ...prevFields, focused: name }));
  };

  return (
    <div className='row'>
      <div className='col-lg-6 col-md-12'>
        <div className='input-group mb-3'>
          <div className='area'>
            <label htmlFor='card'>
              <i className='las la-credit-card' />
            </label>
            <InputMask
              {...register('number', {
                required: {
                  value: paymentMethod === 'card',
                  message: 'Informe um número válido',
                },
                validate: (value) => {
                  return value.replace(/\D/g, '').length >= 16;
                },
              })}
              autoComplete='cc-number'
              id='number'
              type='tel'
              placeholder='Número do Cartão'
              onKeyUp={handleInputChange}
              onFocus={handleInputFocus}
              mask='9999 9999 9999 999999'
              maskChar=''
              className={
                errors.number ? 'form-control is-invalid' : 'form-control'
              }
            />
            <div className='input-error'>{errors?.number?.message}</div>
          </div>
        </div>

        <div className='date form-group mb-3'>
          <div className='input-group'>
            <div className='area'>
              <label htmlFor='cc-exp'>
                <i className='las la-calendar-minus'></i>
              </label>

              <InputMask
                {...register('expiry', {
                  required: {
                    value: paymentMethod === 'card',
                    message: 'Data é obrigatória',
                  },
                  validate: (e) =>
                    e.replaceAll('/', '').replaceAll('_', '').length === 4,
                })}
                autoComplete='cc-exp'
                id='expiry'
                type='tel'
                placeholder='MM/AA'
                onKeyUp={handleInputChange}
                onFocus={handleInputFocus}
                mask='99/99'
                className={
                  errors.expiry ? 'form-control is-invalid' : 'form-control'
                }
                // disabled={disabled}
              />
              <div className='input-error'>{errors?.expiry?.message}</div>
            </div>
          </div>
          <div className='input-group'>
            <div className='area'>
              <label htmlFor='cvc'>
                <i className='las la-lock'></i>
              </label>
              <Form.Control
                {...register('cvc', {
                  required: {
                    value: paymentMethod === 'card',
                    message: 'CVC é obrigatório',
                  },
                  minLength: 3,
                })}
                onKeyUp={handleInputChange}
                onFocus={handleInputFocus}
                maxLength={4}
                autoComplete='cc-csc'
                id='cvc'
                type='text'
                placeholder='CVC/CVV'
                className={errors.cvc ? 'is-invalid' : null}
              />
              <div className='input-error'>{errors?.cvc?.message}</div>
            </div>
          </div>
        </div>
        <div className='input-group mb-3'>
          <div className='area'>
            <label htmlFor='name'>
              <i className='las la-user' />
            </label>
            <Form.Control
              {...register('cardHolder', {
                minLength: 3,
                required: {
                  value: paymentMethod === 'card',
                  message: 'Nome é obrigatório',
                },
              })}
              onKeyUp={handleInputChange}
              onFocus={handleInputFocus}
              autoComplete='cc-name'
              id='cardHolder'
              className={errors.cardHolder ? 'is-invalid' : null}
              type='text'
              placeholder='Nome do titular'
            />
            <div className='input-error'>{errors?.cardHolder?.message}</div>
          </div>
        </div>
        {offer.payment.type === 'single' && (
          <>
            <span className='installments-options'>Opções de parcelamento</span>
            <Form.Control
              {...register('installments', {
                required: paymentMethod === 'card',
              })}
              as='select'
              defaultValue={getValues('installments')}
            >
              {installmentsList.map((item, index) => {
                return (
                  <option value={item.n} key={index}>
                    {item.n}x de {currency(item.price)}
                    {item.n > 1 && offer.payment.student_pays_interest
                      ? '*'
                      : ''}
                  </option>
                );
              })}
            </Form.Control>
          </>
        )}
      </div>
      <div className='card-preview col-lg-6 col-md-12 border-left'>
        <Cards
          focused={fields.focused}
          cvc={fields.cvc}
          expiry={fields.expiry}
          name={fields.cardHolder}
          number={fields.number}
          locale={{ valid: 'validade' }}
          placeholders={{ name: 'Titular do Cartão' }}
        />
      </div>
    </div>
  );
};

export default MethodCard;
